<template>
  <b-modal
    id="submit-report-details"
    :title="$translate('submit_report')"
    hide-footer
    centered
    content-class="rounded-8"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <h5>
          {{ 'submit_report_question' | i18n }}
        </h5>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between mt-3">
        <b-button
          variant="outline-secondary"
          size="lg"
          class="btn-delete-device mr-3 px-75"
          @click="() => onSubmit(false)"
        >
          {{ 'no' | i18n }}
        </b-button>
        <b-button
          variant="outline-primary"
          size="lg"
          class="btn-delete-device px-75"
          @click="() => onSubmit(true)"
        >
          {{ 'yes' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'SubmitReportDetails',
  props: {
    onSubmitReport: {
      type: Function,
      default: () => {},
    }
  },
  methods: {
    onSubmit(isChangeCaseStatus) {
      this.onSubmitReport(isChangeCaseStatus);
      this.$root.$emit('bv::hide::modal', 'submit-report-details');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}
.px-75 {
  padding-left: 75px;
  padding-right: 75px;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
